<template lang="html">
  <PageHeader />
  <section class="refund-policy mt-stickybar home">
    <div class="inner-page-content py-5">
      <div class="container">
        <div v-html="Details"></div>

        <!-- <div class="row"> -->
          <!-- <div class="col-md-12">
            <h2>{{ refundPolicy.title }}</h2>
            <div v-for="(widgetDetails, index) in refundPolicy.widgets" :key="index">
              <h5 class="mb-4">{{ widgetDetails.title }}</h5>
              <ul
                class="ms-4 mb-3"
                v-for="(pageMetaList, index) in widgetDetails.details"
                :key="index"
              >
                <li>
                  {{ pageMetaList.description }}
                </li>
              </ul>
            </div>
          </div> -->
          <!-- <div class="col-md-12">
            <h2>Refund policy</h2>
            {{ refundPolicy }}
            <h5 class="mb-2">Returns</h5>
            <ul class="ms-4 mb-4">
              <li>
                Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately
                we can’t offer you a refund or exchange.
              </li>
              <li>
                To be eligible for a return, your item must be unused and in the same condition that
                you received it. It must also be in the original packaging.
              </li>
              <li>To complete your return, we require a receipt or proof of purchase.</li>
            </ul>
            <h5 class="mb-2">Refunds (if applicable)</h5>
            <ul class="ms-4 mb-4">
              <li>
                Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.
              </li>
              <li>
                If you are approved, then your refund will be processed, and a credit will
                automatically be applied to your credit card or original method of payment, within a
                certain amount of days.
              </li>
            </ul>
            <h5 class="mb-2">Late or missing refunds (if applicable)</h5>
            <ul class="ms-4 mb-4">
              <li>If you haven’t received a refund yet, first check your bank account again.</li>
              <li>
                Then contact your credit card company, it may take some time before your refund is
                officially posted.
              </li>
              <li>
                Next contact your bank. There is often some processing time before a refund is
                posted.
              </li>
              <li>
                If you’ve done all of this and you still have not received your refund yet, please
                contact us at info@onanoff.com.
              </li>
            </ul>
            <h5 class="mb-2">Sale items (if applicable)</h5>
            <ul class="ms-4 mb-4">
              <li>
                Only regular priced items may be refunded, unfortunately sale items cannot be
                refunded.
              </li>
            </ul>
            <h5 class="mb-2">Exchanges (if applicable)</h5>
            <ul class="ms-4 mb-4">
              <li>
                We only replace items if they are defective or damaged. If you need to exchange it
                for the same item, send us an email at info@onanoff.com.
              </li>
            </ul>
            <h5 class="mb-2">Gifts</h5>
            <ul class="ms-4 mb-4">
              <li>
                If the item was marked as a gift when purchased and shipped directly to you, you’ll
                receive a gift credit for the value of your return. Once the returned item is
                received, a gift certificate will be mailed to you.
              </li>
              <li>
                If the item wasn’t marked as a gift when purchased, or the gift giver had the order
                shipped to themselves to give to you later, we will send a refund to the gift giver
                and he will find out about your return.
              </li>
            </ul>
            <h5 class="mb-2">Shipping</h5>
            <ul class="ms-4 mb-4">
              <li>
                You will be responsible for paying for your own shipping costs for returning your
                item. Shipping costs are non-refundable.
              </li>
              <li>
                Depending on where you live, the time it may take for your exchanged product to
                reach you, may vary.
              </li>
              <li>
                If you are shipping an item over $75 USD, you should consider using a trackable
                shipping service or purchasing shipping insurance. We don’t guarantee that we will
                receive your returned item.
              </li>
            </ul> -->
          <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
  </section>
  <PageFooter />
</template>

<script lang="js">
import { useStore } from 'vuex';
import { ref, computed } from 'vue';

import PageHeader from '@/components/commons/PageHeader.vue';
import PageFooter from '@/components/commons/PageFooter.vue';
// import PageService from '@/services/PageService';
// eslint-disable-next-line import/no-extraneous-dependencies
import DOMPurify from 'dompurify';
// const pageService = new PageService();

export default {
  name: 'RefundPolicy',
  props: [],
  components: {
    PageHeader,
    PageFooter,
  },
  setup() {
    const store = useStore();
    const langCode = localStorage.getItem('LangCode');

    const Data = {
      code: langCode,
      slug: `refund_policy_${langCode}`,

    };
    store.dispatch('fetchCMS', Data);

    const refundPolicy = computed(() => store.getters.getCMS);
    const Details = computed(() => DOMPurify.sanitize(refundPolicy.value.html_description));

    return { refundPolicy, langCode, Details };
  },
  mounted() {
    // pageService.getRefundPolicyContent()
    //   .then((res) => {
    //     console.log('res', res);
    //   });
  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {
  },
};
</script>

<style scoped lang="scss"></style>
